export class Idp {
    'id';
    'providerName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerName",
            "baseName": "providerName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Idp.attributeTypeMap;
    }
    constructor() {
    }
}
